import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCompassRound: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"compass-round, browser, safari, web, internet, navigation"} maskId="square-filled-radius-0-stroke-1-IconCompassRound"><path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM15.3171 8.68164L14.2108 14.2128L8.67969 15.319L9.78592 9.78787L15.3171 8.68164Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCompassRound;
